import { LinkTo } from '@ember/routing';
import type { TOC } from '@ember/component/template-only';
import type { Recipe } from '../schemas/recipe.ts';
import imageFadeIn from '../modifiers/image-fade-in';
import tw from '../helpers/tw';

interface RecipeCardSignature {
  Args: {
    recipe: Recipe;
  };
}

const RecipeCard: TOC<RecipeCardSignature> = <template>
  <LinkTo
    @route="explore.recipe"
    @model={{@recipe.id}}
    class={{tw
      "card bg-base-100 no-underline shadow-md transition-shadow hover:shadow-lg"
      (if @recipe.sourceThumbnailUrl "card-side")
    }}
  >
    {{#if @recipe.sourceThumbnailUrl}}
      <figure class="w-28 shrink-0 overflow-hidden">
        <img
          {{imageFadeIn}}
          src={{@recipe.sourceThumbnailUrl}}
          alt={{@recipe.name}}
          class="h-full w-full object-cover opacity-0 transition-opacity duration-300"
          loading="lazy"
        />
      </figure>
    {{/if}}
    <div class="card-body p-4">
      <h3 class="card-title text-base">
        {{#if @recipe.categoryEmoji}}
          <span aria-hidden="true">{{@recipe.categoryEmoji}}</span>
        {{/if}}
        {{@recipe.name}}
      </h3>
      <div class="flex flex-wrap gap-2">
        {{#if @recipe.cuisine}}
          <span class="badge badge-sm badge-accent">{{@recipe.cuisine}}</span>
        {{/if}}
        {{#if @recipe.difficulty}}
          <span
            class="badge badge-sm badge-outline"
          >{{@recipe.difficulty}}</span>
        {{/if}}
        {{#if @recipe.cookTimeMinutes}}
          <span class="badge badge-sm badge-ghost">{{@recipe.cookTimeMinutes}}
            min</span>
        {{/if}}
      </div>
      {{#if @recipe.summary}}
        <p class="text-base-content/70 mt-1 line-clamp-2 text-sm">
          {{@recipe.summary}}
        </p>
      {{/if}}
      {{#if @recipe.ingredientCount}}
        <div class="text-base-content/50 mt-2 text-xs">
          {{@recipe.ingredientCount}}
          ingredients &middot;
          {{@recipe.stepCount}}
          steps
        </div>
      {{/if}}
    </div>
  </LinkTo>
</template>;

export default RecipeCard;
